import { UserRoles } from 'src/types/User';

// Access policy alignment:
// - 'Free-User' => '/cct' and '/ttt' (and '/free' showcase)
// - 'User' => all app modules
// - 'Admin' => all (implicit)
// - 'Product2' => reserved; not used in current UI routes

const freePaths = new Set<string>(['/cct', '/ttt']);

export function requiredRoleForPath(path: string): UserRoles[] {
  // Routes only a Free-User can access (plus higher roles)
  if (freePaths.has(path)) return ['Free-User', 'User', 'Admin'];
  // All other known modules require 'User' (Admin also allowed)
  return ['User', 'Admin'];
}

export function userHasAccess(userRoles: UserRoles[] = [], requiredAny: UserRoles[]): boolean {
  if (!Array.isArray(requiredAny) || requiredAny.length === 0) return true;
  if (userRoles.includes('Admin')) return true;
  return userRoles.some((r) => requiredAny.includes(r));
}
